'use client';

import { FileText, ArrowRight } from 'lucide-react';
import Button from '@/components/ui/Button';

// Short-quiz-only promo for the long quiz, framed around the personalized
// report (the "Personal Political Profile"). Sits in the results left column,
// which is otherwise sparse on the short quiz since the paid-report upsell
// (PdfReportUpsell) only renders for long-quiz takers. The button starts the
// free 60-question quiz, which is the path to the report.
export default function LongQuizReportCard({
  onStart,
  showCarryOver = false,
  className = '',
}: {
  onStart: () => void;
  /** Only true when this browser holds a completed short session, i.e. the
   *  viewer is the quiz taker (not someone opening a shared result), so the
   *  carry-over promise is actually true for them. */
  showCarryOver?: boolean;
  className?: string;
}) {
  return (
    <div
      className={`flex flex-col rounded-2xl bg-white border border-[#16223d]/10 ring-1 ring-[#16223d]/5 shadow-[0_4px_6px_rgba(28,35,33,0.06),0_24px_48px_rgba(28,35,33,0.08)] p-5 ${className}`}
    >
      <div className="flex items-center gap-2 mb-1">
        <FileText className="w-5 h-5 text-slate-700" aria-hidden="true" />
        <h3 className="text-lg font-bold text-foreground">Get your personal report</h3>
      </div>
      <p className="text-sm text-foreground/60 leading-snug mb-3">
        Finish the 60-question quiz to narrow your region down to one ideology
        and to order the Personal Political Profile, a report of more than 30
        pages on the thinkers and arguments behind your politics.
      </p>
      {showCarryOver && (
        // "Nearly 20%": 11 of the 12 short answers are guaranteed to carry
        // (the 12th is a boundary tiebreaker that only enters the long quiz
        // later, via replacement), so 11/60 = 18%. Don't promise "12" or a
        // flat "20%": the in-quiz banner shows the real count and percent.
        <p className="text-sm font-semibold text-foreground/80 leading-snug mb-4">
          Your answers carry over, so you start about a fifth of the way in.
        </p>
      )}
      <Button
        type="button"
        onClick={onStart}
        className="mt-auto w-full"
      >
        Take the 60-question quiz <ArrowRight className="w-5 h-5" aria-hidden="true" />
      </Button>
    </div>
  );
}
